<template>
  <div class="home-content-box home-video-box">
    <div class="home-content-body body-max-container">
      <ul>
        <li>
          <div class="home-content-info">
            <div class="home-content-info-body">
              <div class="title">走出電影種下教育的種子</div>
              <div class="subTitle">The seeds of education</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="swiperOptions" class="swiper">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="resource in getResourceList" :key="`HOME_VIDEO_${resource.resourceId}`">
          <div class="swiper-card-box" @click="handleGoResourceIndex(resource)">
            <img :src="getPreviewUrl(resource)" alt />
            <h5 class="tag"># {{ resource.resourceType  | filterTag }}</h5>
            <h1 class="title">{{ resource.title }}</h1>
            <div v-if="resource.downloadByMember" class="star-box">
              <div class="star-span-box">
                <span>會員</span>
                <br>
                <span>下載!</span>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination">
        </div>
      </swiper>
    </div>
    <div class="swiper-button-prev enter-btn" @click.stop="handlePrev"></div>
    <div class="swiper-button-next enter-btn" @click.stop="handleNext"></div>
    <div class="enter-box body-max-container">
      <img class="enter-btn" src="../../../assets/img/icon-arrow-right.svg" alt @click="goResource" />
    </div>
  </div>
</template>

<script>
import { DeviceTypeEnum } from "@/utils/enum";
import { ResourceModel } from "@/models/resource-model";
import IndexMixin from "@/mixins/index-mixin";
import { resourceGroupOptionsKeyValue } from "@/utils/options"
import { fetchResourceList } from "@/apis/resource";
import { ResponseModel } from "@/models/response-model";

export default {
  name: "HomeVideos",
  mixins: [IndexMixin],
  filters: {
    filterTag: function(val) {
      return resourceGroupOptionsKeyValue[val]
    }
  },
  data() {
    return {
      swiperOptions: null
    };
  },
  computed:{
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  created() {
    this.setupSwiper()
    this.$nextTick(() => {
      window.addEventListener('resize', this.setupSwiper)
    })
  },
  mounted() {
    if (this.getResourceList.length === 0) {
      // this.openLoading()
      fetchResourceList().then(res => {
        // this.closeLoading()
        const response = new ResponseModel(res)
        if (response.isSuccess) {
          const { resourceList } = response.result
          const resourceModels = []
          for (const i in resourceList) {
            resourceModels.push(new ResourceModel(resourceList[i]))
          }
          this.$store.dispatch("app/saveResourceList", resourceModels)
        }
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setupSwiper)
  },
  methods: {
    handlePrev() {
      this.swiper.slidePrev()
    },
    handleNext() {
      this.swiper.slideNext()
    },
    /**
     * @param {ResourceModel} row
     */
    getPreviewUrl(row) {
      if (row.resourcePreviewVertical && row.resourcePreviewVertical !== "") {
        return this.getResourceUrl(row.resourcePreviewVertical)
      } else if (row.resourcePreview && row.resourcePreview !== "") {
        return this.getResourceUrl(row.resourcePreview)
      } else {
        return ""
      }
    },
    setupSwiper() {
      // console.log('setupSwiper')
      // this.swiperOptions = null
      const swiperOptions = {
        // rewind: true,
        slidesPerView: 5.1,
        spaceBetween: 20,
        speed: 500,
        freeMode: false,
        loop: false,
        centeredSlides: false,
        // grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          // bulletActiveClass: "paging-bullet-active",
          // bulletClass: "paging-bullet",
        },
        navigation:  {
          nextEl:   '.swiper-button-next' ,
          prevEl:   '.swiper-button-prev'
        }
      }
      // console.log(this.$store.getters.device)
      if (this.$store.getters.device === DeviceTypeEnum.TABLET) {
        swiperOptions.slidesPerView = 4.1
      } else if (this.$store.getters.device === DeviceTypeEnum.MOBILE) {
        swiperOptions.slidesPerView = 1.5
        swiperOptions.loop = true
        swiperOptions.centeredSlides = true
        // swiperOptions.pagination = null
      }
      this.swiperOptions = swiperOptions
      this.$nextTick(() => {
        this.$refs.mySwiper.initSwiper()
      })
    },
    goResource() {
      this.$router.push({ name: "ResourceIndex" });
    },
    /**
     * @param {ResourceModel} resource
     */
    handleGoResourceIndex(resource) {
      let routerName = ''
      if (resource.resourceType === 1) {
        routerName = "ResourceVideo";
      } else if (resource.resourceType === 3) {
        routerName = "ResourceVisual"
      } else if (resource.resourceType === 4) {
        routerName = "ResourceLazyBag"
      }
      if (routerName !== '') {
        this.$router.push({
          name: routerName,
          params: {
            id: resource.resourceId,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.swiper-button-prev {
  width: 60px !important;
  height: 60px !important;
  color: white !important;
  //background: black !important;
  border-radius: 50% !important;
}
.swiper-button-prev:after {
  font-size: 50px;
}
.swiper-button-next {
  width: 60px !important;
  height: 60px !important;
  color: white !important;
  //background: black !important;
  border-radius: 50% !important;
}
.swiper-button-next:after {
  font-size: 50px;
}
</style>
